<div id="switcherBar">
	<select (change)="getAppsSelect($event)" id="lstApps"></select>
</div>
